<template>
  <div class="m-content-asset__main-content">
    <div class="m-sample-service animatedParent animateOnce">
      <div class="c-video-banner c-video-banner--fifth layout">
        <div class="ms-row c-video-banner__inner">
          <div class="col-xs-12 col-sm-10 col-sm-offset-2 col-md-offset-0 col-md-6 col-lg-7 center-xs end-sm start-md c-video-banner__column">
            <div class="c-video-banner__video-holder">
              <img class="c-video-banner__img--full-width-mob lazyloaded" :alt="config.title" :src="config.src">
            </div>
          </div>
          <div class="col-xs-12 col-md-5 col-md-offset-1 col-lg-offset-0 c-video-banner__column">
            <div class="c-video-banner__text-holder animated fadeInRight delay-250 go" style="background-color: #8c9a65;">
              <div class="c-video-banner__subtitle heading-h5 text--uppercase animated fadeInRight delay-500 go" style="color: #fff;">{{config.subtitle}}</div>
              <div class="c-video-banner__title heading-h1 animated fadeInRight delay-500 go" style="color: #fff;">{{config.title}}</div>
              <div class="c-video-banner__description animated fadeInRight delay-500 go" style="color: #fff;">
                <p v-html="htmlify(config.desc)"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="c-video-banner__colored-box" style="background-color: #8c9a65;">&nbsp;</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImageTextAnimate",
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  methods: {
    htmlify(str) {
      return str.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>');
    }
  }
}
</script>

<style lang="scss" scoped>
 .m-sample-service { position: relative; margin-bottom: 6.25rem; }
 .c-video-banner { z-index: 2; }
  // 左边
 .c-video-banner__video-holder { width: 85%; }
 .c-video-banner--fifth .c-video-banner__video-holder { width: 100%; }
 .c-video-banner__img--full-width-mob { width: 100%; }
  // 右边
 .c-video-banner__text-holder { padding: 2.1875rem 4.0625rem 3.4375rem 3.875rem; }
 .c-video-banner--fifth .c-video-banner__text-holder { padding: 3.375rem 1.125rem 4.9375rem; }
 .c-video-banner--fifth .c-video-banner__title { font-size: 3.125rem; margin-bottom: 2.625rem; max-width: 23.1875rem; }
 .c-video-banner--fifth .c-video-banner__description { padding-bottom: 2.5rem; }
  //  
 .c-video-banner__colored-box { position: absolute; bottom: 0; right: 0; z-index: 1; width: 100%; height: 80%; background-color: #d2bbb8; }
 .c-video-banner--fifth + .c-video-banner__colored-box { display: none; }

  @media screen and (min-width: 48em) {
    .m-sample-service { padding: 0 3.875rem 0 0; }
    // 左边
    .c-video-banner__img--full-width-mob { width: auto; }
    // 右边
    .c-video-banner__text-holder { padding: 3.4375rem 11.875rem 3.125rem 37%; }
    .c-video-banner--fifth .c-video-banner__text-holder { width: 80%; padding: 3.4375rem 4.0625rem 4.6875rem; }
    .c-video-banner--fifth .c-video-banner__title { margin-bottom: .625rem; max-width: 100%; }
    // 
    .c-video-banner__colored-box { width: 80%; }
    .c-video-banner--fifth + .c-video-banner__colored-box { display: block; height: 60%; left: 0; right: auto; }
  }

  @media screen and (min-width: 64em) {
    .m-sample-service { padding: 0 1.875rem 0 0; }
    .c-video-banner--fifth { padding-top: 10.25rem; }
    // 左边
    .c-video-banner--fifth .c-video-banner__column:first-child { z-index: 1; }
    .c-video-banner__video-holder { width: 100%; margin: -2.5rem 0 2.5rem; }
    // 右边
    .c-video-banner__text-holder { position: absolute; top: 50%; transform: translateY(-50%) translateY(-.5px); padding: 3.125rem 2.0625rem 3.125rem 7%; }
    .c-video-banner--fifth .c-video-banner__text-holder { width: auto; top: 0; transform: none; margin-left: -11.875rem; padding: 5rem 6.375rem; }
    .c-video-banner--fifth .c-video-banner__title { max-width: 23.1875rem; }
    // 
    .c-video-banner__colored-box { height: 100%; width: 50%; }
    .c-video-banner--fifth + .c-video-banner__colored-box { display: none; }
  }

  @media screen and (min-width: 75em) {
    .m-sample-service { padding-right: 0; }
    .c-video-banner--fifth .c-video-banner__inner { margin: 0; }
    .c-video-banner--fifth .c-video-banner__column { padding: 0; }
    // 左边
    .c-video-banner--fifth .c-video-banner__video-holder { margin: 0 0 0 -5.1875rem; padding-right: 1.25rem; }
    // 右边
    .c-video-banner__text-holder { padding: 6.25rem 5.1875rem 6.25rem 7%; }
    .c-video-banner--fifth .c-video-banner__text-holder { padding: 7.5rem 6.375rem; }
  }
</style>